import classNames from 'classnames';
import React from 'react';

import HideValidationPopupsContext from 'sharedreact/contexts/HideValidationPopupsContext';

// Adds hidden to the className of an existing component and makes
// a hideValidationPopups prop available in its context
function hideable<P, S> (WrappedComponent: React.ComponentClass<P, S>) {
  let displayName = WrappedComponent.displayName || WrappedComponent.name || 'Hideable';
  displayName = displayName !== 'Hideable'
    ? 'hideable(' + displayName + ')'
    : displayName;

  type Props = {
    hidden?: boolean,
    hideValidationPopups?: boolean,
    className?: string
  };

  class Hideable extends React.Component<P & Props> {
    static displayName = displayName;
    
    static contextType = HideValidationPopupsContext;
    context!: React.ContextType<typeof HideValidationPopupsContext>

    override render (): React.ReactNode {
      const {
        hidden,
        hideValidationPopups,
        className
      } = this.props;
      
      // copy the props.
      let props: P & Props = {...this.props};

      // adapt className.
      props.className = classNames(
        className,
        {hidden: hidden});

      // strip props attributes that are specific to hideable.
      delete props.hidden;
      delete props.hideValidationPopups;

      // pass through the modified props
      return (
        <HideValidationPopupsContext.Provider value={hidden || hideValidationPopups || false}>
          <WrappedComponent {...props}/>
        </HideValidationPopupsContext.Provider>);
    }
  }

  return Hideable;
}

export default hideable;
